import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
    selector: 'tracker-queries-dropdown',
    template: require('./tracker.queries.dropdown.component.html'),
})
export class TrackerQueriesDropdownComponent implements OnInit {
    @Input() id: string;
    @Input() queries: any[];

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    tree: any;
    tracker: any;
    query: any;
    initialItem = { section: 'trackerquery', id: null };

    constructor(private stateService: StateService, ) { }

    ngOnInit() {
        this.tree = this.getTrackerQueryTree(this.queries);
        [this.tracker, this.query] = this.getSelectedItems(this.tree, this.stateService.params);
        this.initialItem = 
            this.query?.id ? { section: 'trackerquery', id: this.query.id } :
            this.tracker?.id ? { section: 'tracker', id: this.tracker.id } :
            { section: null, id: null };
    }

    selectItem(item: any) {
        if (!item) return;

        // Is this a query?
        if (item.id && item.tracker) {
            const params = {
                tracker: item.tracker.id,
                query: item.id,
                page_num: 1
            };

            this.stateService.go('.', params, { notify: true, location: true, reload: false })
                .then(() => {
                    this.onSelect.emit(params);
                });

            this.closeDropdown();
        }
    }

    stateGo(stateName: string, params: any) {
        this.stateService.go(stateName, params);
    }

    closeDropdown() {
        // Find the parent .btn-group
        const dropdown = document.querySelector('.btn-group.open');
        if (dropdown) {
            dropdown.classList.remove('open');
        }
    }

    private getSelectedItems(tree: any[], params: any) {
        const queryId = params?.query;

        let tracker, query;

        // Override the tracker in params with the tracker for
        // the selected query, if specified.
        _.forEach(tree, (t) => {
            const q = _.find(t.children, (candidate) => candidate.id == queryId);
            if (q) {
                tracker = t;
                query = q;
            }
        });

        // No query?  Use the tracker in the params.
        if (!query) {
            const trackerId = params?.tracker;
            tracker = _.find(tree, (candidate) => candidate.id == trackerId);
        }

        return [tracker, query];
    }

    private getTrackerQueryTree(queries: any[]) {
        return _.map(queries, (t) => {
            const children = _.map(t.queries, (q) => {
                return {
                    section: 'trackerquery',
                    name: q.queryName,
                    id: q.id,
                    tracker: t,
                };
            });

            return {
                section: 'tracker',
                name: t.trackerName,
                id: t.id,
                children: children,
            };
        });
    }
}
